import ServiceSummary from './ServiceSummary';

export default ServiceSummary;
